import React from 'react';
import { Route, withRouter } from 'react-router';
import Disclaimer from '../Disclaimer/disclaimer';
import EditDisclaimer from '../Disclaimer/editDisclaimer';
import Templates from './Orders/Components/Templates/Templates';
import AddTemplate from './Orders/Components/Templates/AddTemplate';
import SportNotification from './SportNotification/SportNotification';
import EditSportNotification from './SportNotification/EditSportNotification';
import Advertisements from './Advertisements/Advertisements';
import Sponsors from './Sponsors/Sponsors';

function ToolsAndSettings(props) {
	return <>
		<Route path={`${props.match.path}/disclaimer`}>
			<Route path={`${props.match.path}/disclaimer`} exact>
				<Disclaimer type={'Disclaimers'} />
			</Route>
			<Route path={`${props.match.path}/disclaimer/edit`} exact>
				<EditDisclaimer type={'Disclaimers'} />
			</Route>
		</Route>
		<Route path={`${props.match.path}/policy`}>
			<Route path={`${props.match.path}/policy`} exact>
				<Disclaimer type={'Policies'} />
			</Route>
			<Route path={`${props.match.path}/policy/edit`} exact>
				<EditDisclaimer type={'Policies'} />
			</Route>
		</Route>
		<Route path={`${props.match.path}/headline`}>
			<Route path={`${props.match.path}/headline`} exact>
				<Disclaimer type={'Headlines'} />
			</Route>
			<Route path={`${props.match.path}/headline/edit`} exact>
				<EditDisclaimer type={'Headlines'} />
			</Route>
		</Route>
		<Route path={`${props.match.path}/templates`}>
			<Route path={`${props.match.path}/templates`} exact>
				<Templates />
			</Route>
			{/* <Route path={`${props.match.path}/templates/add-template`} exact>
				<AddTemplate />
			</Route> */}
			<Route path={`${props.match.path}/templates/edit-template/:id`} exact>
				<AddTemplate />
			</Route>
		</Route>
		<Route path={`${props.match.path}/notification-banner`}>
			<Route path={`${props.match.path}/notification-banner`} exact>
				<Disclaimer type={'Notification'} />
			</Route>
			<Route path={`${props.match.path}/notification-banner/edit`} exact>
				<EditDisclaimer type={'Notification'} />
			</Route>
		</Route>
		<Route path={`${props.match.path}/sport-notification`}>
			<Route path={`${props.match.path}/sport-notification`} exact>
				<SportNotification />
			</Route>
			<Route path={`${props.match.path}/sport-notification/:id`} exact>
				<EditSportNotification />
			</Route>
		</Route>
		<Route path={`${props.match.path}/sponsors`}>
			<Route path={`${props.match.path}/sponsors`} exact>
				<Advertisements />
			</Route>
		</Route>
		<Route path={`${props.match.path}/advertisements`}>
			<Route path={`${props.match.path}/advertisements`} exact>
				<Sponsors />
			</Route>
		</Route>
	</>
}

export default withRouter(ToolsAndSettings);